import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Confirm, themes } from 'libs/ui';
import { TariffSetForm } from 'libs/forms';

export const SetTariff = (props) => {
  const { parkingId, tariffId, action, close } = props;
  const { t } = useTranslation();
  const [confirm, setConfirm] = useState(false);
  const [working, setWorking] = useState(false);
  const [selectedTariffId, setSelectedTariffId] = useState('');

  /**
   * show confirm
   * @param {*} param0
   */
  const showConfirm = ({ tariff_id }) => {
    setSelectedTariffId(tariff_id);
    setConfirm(true);
  };

  /**
   * update tariff
   */
  const updateTariff = async () => {
    setConfirm(false);
    setWorking(true);
    await action({ tariff_id: selectedTariffId });
    setWorking(false);
    close();
  };

  return (
    <>
      <TariffSetForm working={working} action={showConfirm} close={close} parkingId={parkingId} tariffId={tariffId} />

      {confirm && (
        <Confirm
          width={'550px'}
          title={t('form.Тарификация данной парковочной сессии будет изменена. Продолжить?')}
          type="danger"
          cancelButton={{
            text: t('buttons.Отменить'),
            func: () => {
              setConfirm(false);
            },
          }}
          acceptButton={{
            text: t('buttons.Заменить'),
            func: () => {
              updateTariff();
            },
            theme: themes.red,
          }}
        />
      )}
    </>
  );
};

SetTariff.propTypes = {
  parkingId: PropTypes.any,
  tariffId: PropTypes.any.isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
};
